import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-calendar',
	templateUrl: './icon-calendar.component.svg',
})
export class IconCalendarComponent {}
